import { Box, Card, type CardRootProps } from "@chakra-ui/react"
import { forwardRef } from "react"

export interface AppCardProps extends Omit<CardRootProps, "title"> {
  children: React.ReactNode
  padding?: string | number
  headerTitle?: React.ReactNode
  footer?: React.ReactNode
}

export const AppCard = forwardRef<HTMLDivElement, AppCardProps>(
  (props, ref) => {
    const { children, padding = "6", headerTitle, footer, ...rest } = props

    return (
      <Card.Root
        ref={ref}
        variant="outline"
        borderRadius="2xl"
        boxShadow="subtle"
        border="1px solid"
        borderColor="border.subtle"
        bg="bg.panel"
        overflow="hidden"
        {...rest}
      >
        {headerTitle && (
          <Card.Header pb="2">
            <Box fontWeight="bold">{headerTitle}</Box>
          </Card.Header>
        )}
        <Card.Body p={padding}>{children}</Card.Body>
        {footer && <Card.Footer pt="2">{footer}</Card.Footer>}
      </Card.Root>
    )
  }
)

AppCard.displayName = "AppCard"
